// engine
import { appDispatcher, ArController, assetsService, currencyService, gameDispatcher, helper, textStyleService, translationService } from '@aceroll/core';

// hacksaw
import { HsCurrencyFormatter, HsTextFormatter } from '@aceroll/platform-hacksaw';

export class Preloading extends ArController {
	async onStart() {
		try {
			await assetsService.createManifest(['font', 'bitmap-font', 'image', 'spine', 'spritesheet', 'text-style']);
			await assetsService.createSoundManifest();
			await assetsService.loadStage(0);

			this.#setupTranslations();
			this.#setupTextStyles();
			this.#setupCurrency();

			this.stop();
		} catch (e) {
			helper.error(e.message, { title: 'Preloading Controller Error' });
			this.fail();
		}
	}

	#setupTranslations() {
		translationService.setFormatter(new HsTextFormatter());
	}

	#setupTextStyles() {
		const styles = [
			appDispatcher.getAsset('style-base')
		];

		const { localeCode } = gameDispatcher.state;

		const languageStyles = appDispatcher.getAsset('style-language')[localeCode];

		if (languageStyles) {
			styles.push(languageStyles);
		}

		textStyleService.setStyles(...styles);
	}

	#setupCurrency() {
		currencyService.setFormatter(new HsCurrencyFormatter);
	}
}
